import React, { FC } from "react";
import classNames from "classnames";

import { Avatar, Pill } from "../../common";
import { STATUS_CONFIG } from "../../../constants";
import { StatusSet } from "../../../types/GlobalTypes";

const STATUS_PROPS = STATUS_CONFIG[StatusSet.CONTACT];

type Props = {
  title?: string;
  text: string;
  status?: string;
  className?: string;
  selected?: boolean;
  onClick?: () => void;
};

export const ContactCard: FC<Props> = ({
  title,
  text,
  status,
  selected = false,
  className,
  onClick,
}) => {
  return (
    <div
      className={classNames(
        "flex flex-row items-center w-full rounded-lg p-4 justify-between",
        className,
        selected
          ? "border-2 border-green-500 bg-green-50"
          : "border border-violet-100 bg-white",
        {
          "cursor-pointer": !!onClick,
        }
      )}
      onClick={onClick}
    >
      <Avatar title={text} className="basis-auto shrink-0 grow-0" />

      <div className="ml-6 flex flex-col">
        {title && (
          <div className="flex uppercase text-sm text-violet-300 break-all">
            {title}
          </div>
        )}

        <div className="capitalize text-base text-gray-500 text-wrap">
          {text}
        </div>
      </div>

      {status && (
        <Pill
          {...STATUS_PROPS[status]}
          direction="right"
          className="basis-auto"
        />
      )}
    </div>
  );
};
